import { render, staticRenderFns } from "./sponsorPage.vue?vue&type=template&id=75e1aa5e&scoped=true&"
import script from "./sponsorPage.vue?vue&type=script&lang=js&"
export * from "./sponsorPage.vue?vue&type=script&lang=js&"
import style0 from "./sponsorPage.vue?vue&type=style&index=0&id=75e1aa5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e1aa5e",
  null
  
)

export default component.exports